import React from "react";
import { Navigate } from "react-router-dom";
import { useEmpresa } from "@contexts/EmpresaContext";
import { rotaInicialPorPapel } from "@utils/papeis";
import LoadingScreen from "./LoadingScreen";

// Rota inicial ("/"): leva cada papel à sua tela. Espera a empresa carregar
// porque o papel só é conhecido depois disso; decidir antes mandaria o
// operador ao dashboard, que a API recusa (#117).
const InicioPorPapel = () => {
  const { papelNaEmpresaAtiva, loading } = useEmpresa();

  if (loading) {
    return <LoadingScreen />;
  }

  return <Navigate to={rotaInicialPorPapel(papelNaEmpresaAtiva)} replace />;
};

export default InicioPorPapel;
